import 'react';
import PropTypes from '../../prop-types/index.js';
import './AnimateGroupChild.js';

({
  appear: PropTypes.object,
  enter: PropTypes.object,
  leave: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  component: PropTypes.any
});
